export const cellSizePX = `48px`;
export const buttonSize = 48;
export const backgroundColorInAddButton = `#f4a400`;
export const backgroundColorDeleteButton = `#b10000`;
export const spaceBetweenTableAndButtons = `-2px`;
export const mainColor = `#4aaae7`;
